import { render } from "./PaymentModal.vue?vue&type=template&id=bcac64ee&lang=true"
import script from "./PaymentModal.vue?vue&type=script&lang=js"
export * from "./PaymentModal.vue?vue&type=script&lang=js"

import "./PaymentModal.vue?vue&type=style&index=0&id=bcac64ee&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__